// removed by extract-text-webpack-plugin
module.exports = {"checkout-modal":"checkout-modal","stripe-cardnumber":"stripe-cardnumber","email-error":"email-error","price-on-modal":"price-on-modal","secure-msg":"secure-msg"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Modals/MyStoreCheckout/CheckoutModal.scss
// module id = Ue+K
// module chunks = 0